<div class="ui-g-12 ui-md-12">
  <div *ngIf="!mostrar">
    <i class="pi pi-spin pi-spinner" style="font-size: 5em"></i>

  </div>
  <div *ngIf="calculando">
    <i class="pi pi-spin pi-spinner" style="font-size: 5em"></i>

  </div>
  <div *ngIf="mostrar" id="multiplerow">

    <p-table (sortFunction)="customSort($event)" [customSort]="true" [first]="first" [columns]="cols" [value]="control"
      selectionMode="multiple" [(selection)]="selectedProducts" [paginator]="true" [rows]="20" [autoLayout]="true">
      <ng-template pTemplate="caption" style="background-color: white !important;">
        <div class="header-caption">
          <div class="buscador">
            <i class="fa fa-search" style="margin:4px 4px 0 0"></i>
            <input type="text" pInputText size="50" placeholder="Buscar..." [(ngModel)]="buscador"
              (input)="buscadorEspecial($event.target.value)" style="text-align: left;height: 34px;min-width: 230px;">
          </div>
          <div>
              <p-checkbox name="active" binary="true"  label="Activo" [(ngModel)]="isActive" [binary]="true" inputId="activeInput" (onChange)="onFilter($event)"></p-checkbox>
          </div>
          <!-- Seleccionar cliente -->
          <div style="position:relative;  width: 300px !important;" id="clientes-search">
            <p-dropdown [options]="clientes.filtered" [(ngModel)]="clientes.selected" [filter]="true"
              placeholder="Seleccione">
            </p-dropdown>
          </div>

          <div class="nuevo">
            <button pButton type="button" label="Crear oferta" class="mx-2 btn btn-success"
              (click)="creaOferta()"></button>
          </div>
        </div>


      </ng-template>


      <ng-template pTemplate="header" let-columns>
        <tr>
          <th *ngFor="let col of columns" [pSortableColumn]="col.field">
            {{col.header}}
            <p-sortIcon *ngIf="col.field != 'opciones'" [field]="col.field" ariaLabel="Activate to sort"
              ariaLabelDesc="Activate to sort in descending order"
              ariaLabelAsc="Activate to sort in ascending order"></p-sortIcon>
          </th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-rowData let-columns="columns" let-rowIndex="rowIndex">
        <tr [pSelectableRow]="rowData" [pSelectableRowIndex]="rowIndex">
          <td *ngFor="let col of columns">
            <div [ngSwitch]="col.field">
              <div *ngSwitchCase="'foto'">
                <div *ngIf="rowData.archivo1 && rowData.archivo1.length > 0">
                  <img [src]="urlUploadArticulo+rowData.archivo1" class="image_firma"
                    style="width:30px ;height: 30px; margin: 0;">
                </div>

              </div>
              <div *ngSwitchDefault>
                {{rowData[col.field]}}
              </div>
            </div>
          </td>
        </tr>
      </ng-template>
      <ng-template pTemplate="summary">
        <ul>
          <li *ngFor="let art of selectedProducts" style="text-align: left">
            {{art.id + ' - ' + art.nombre + ' - ' + art.color + ' - ' + art.maceta + ' - ' + art.tamano}}
          </li>
        </ul>
      </ng-template>
    </p-table>

  </div>
</div>
<p-confirmDialog header="Confirmación" icon="pi pi-exclamation-triangle"></p-confirmDialog>


<p-toast [style]="{marginTop: '80px'}"></p-toast>


<!-- OFERTA -->
<p-dialog header="OFERTA" [(visible)]="showOferta" [contentStyle]="{width:'80vw','max-height':'80vh'}" (onShow)="scrollToTop($event)">


  <div>
    <div id="html2canvasDivOferta">
      <div id="logo-mark" class="logo">
        <img [src]="logoBase64" alt="log-vpe vpe vpe-app" />
      </div>
      <div id="info-client" e>
        <div *ngIf="!tituloEnAleman"  style="text-align: right;">
          <p class="large">{{oferta?.nombre}}</p>
          <p class="large">{{oferta?.direccion}}</p>
          <p class="large">{{oferta?.cp}} - {{oferta?.poblacion}}</p>
          <p class="large">{{oferta?.provincia}}</p>
          <p class="large">{{oferta?.pais}}</p>
          <p class="large">{{oferta?.telefono}}</p>
        </div>
        <div *ngIf="tituloEnAleman" style="text-align: right;">
          <p class="large">{{oferta?.nombre}}</p>
          <p class="large">{{oferta?.direccion}}</p>
          <p class="large">{{oferta?.cp}} {{oferta?.poblacion}}</p>
          <p class="large">{{oferta?.provincia}}</p>
          <p class="large">{{oferta?.pais}}</p>
          <p class="large">{{oferta?.telefono}}</p>
        </div>
      </div>
      <div id="table-details" class="details">
        <div class="sub-title" *ngIf="!tituloEnAleman">
          <h4 class="title-table">OFERTA</h4>
          <p >Fecha: {{fecha_actual}} </p>
        </div>
        <div class="sub-title" *ngIf="tituloEnAleman">
          <h4 class="title-table">ANGEBOT</h4>
          <p>Datum: {{fecha_actual}} </p>
        </div>

        <p-table [columns]="colsOffer" [value]="oferta.articulos">
          <ng-template pTemplate="caption">
            DETALLE ARTÍCULOS
        </ng-template>
          <ng-template pTemplate="header" let-yourColumnArrayVaraible>
            <tr>
              <th *ngFor="let yourColumnVaraible of yourColumnArrayVaraible">
                {{yourColumnVaraible.header}}
              </th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-yourRowVaraible let-yourColumnArrayVaraible="columns" let-rowIndex="rowIndex">
            <tr>
              <td *ngFor="let yourColumnVaraible of yourColumnArrayVaraible">
                <div [ngSwitch]="yourColumnVaraible.field">
                  <div *ngSwitchCase="'imagen'">
                    <img [src]="yourRowVaraible[yourColumnVaraible.field]" class="image_firma" style="width:10vw ;height: 15vh; margin: 0;">
                  </div>
                  <div *ngSwitchDefault>
                    {{yourRowVaraible[yourColumnVaraible.field]}}
                  </div>
                </div>
              </td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    </div>
  </div>

  <div class="d-flex justify-content-center">
    <button class="btn btn-dark mx-2" (click)="showOferta = false;">Cerrar</button>
    <button class="btn btn-primary mx-2" (click)="imprimePdf();" [disabled]="isGeneratingCanvas">
      <i class="fa fa-print"></i>
      Imprimir
    </button>
    <button class="btn btn-danger mx-2" (click)="generateExcel();" [disabled]="isGeneratingCanvas">
      <i class="fa fa-file-excel-o"></i>
      Excel
    </button>
    <span *ngIf="isGeneratingCanvas">
      Generando pdf...
    </span>

    <br>
  </div>
</p-dialog>
